import {Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ContentService} from "../../service/content.service";
import {ContentResponse} from "../../interface/contentResponse";
import {ContentType} from "../../interface/contentType";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {UserCardUtil} from "../../utilityClass/userCardUtil";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ContentUpdateRequest} from "../../interface/contentUpdateRequest";

@Component({
  selector: 'app-edit-content',
  templateUrl: './edit-content.component.html',
  styleUrl: './edit-content.component.scss'
})
export class EditContentComponent implements OnInit {
  contentForm: FormGroup | any;
  showError: boolean = false
  contentResponse: ContentResponse | any;
  showFileInput: boolean = false;
  selectedFile: File | any;
  fileSizeExceeded: boolean = false
  currentImage: any
  allowedFileTypes: string[] = ['image/jpeg', 'image/png'];
  @ViewChild('contentIcon') contentIcon: ElementRef<HTMLInputElement> | any;

  constructor(private formBuilder: FormBuilder,
              private contentService: ContentService,
              private dialogRef: MatDialogRef<EditContentComponent>,
              private userCardUtil: UserCardUtil,
              private snackBar: MatSnackBar,
              @Inject(MAT_DIALOG_DATA) private data: any) {
    this.contentService.getContentById(data.content).subscribe({
      next: (userContentResponse: ContentResponse) => {
        this.contentResponse = userContentResponse
        this.initForm()
      },
      error: (error) => {
        this.handleErrorResponse(error)
      }
    })
  }

  ngOnInit() {
    this.initForm()
  }

  closePopUp () {
    this.dialogRef.close()
  }

  onSubmit() {
    if (this.contentForm.valid) {
      const {name, contentType} = this.contentForm.value;

      if (!this.contentResponse) {
        console.error('Content not found for update.');
        return;
      }

      const updatedContent: ContentUpdateRequest = {
        id: this.contentResponse.id,
        name,
        contentType,
      };

      const combinedData = {
        updatedContent: updatedContent,
        contentIcon: this.selectedFile ? this.selectedFile : null
      }
      if (!this.showError) {
        this.dialogRef.close(combinedData)
      }
    } else {
      this.contentForm.markAllAsTouched();
    }
  }

  imageShow() {
    this.selectedFile = null;
    this.showError = true
    this.showFileInput = true
  }

  showImages(event: any) {
    const file = event.target.files[0];
    if (file) {
      const fileSizeInMB: number = file.size / (1024 * 1024);
      const maxSizeInMB: number = 5;
      const fileType: string = file.type.toLowerCase();
      this.selectedFile = file;
      this.currentImage = URL.createObjectURL(file);
      this.showError = false
      this.showFileInput = false;
      this.fileSizeExceeded = false;

      if (fileSizeInMB > maxSizeInMB && !this.allowedFileTypes.includes(fileType)) {
        event.target.value = '';
        this.fileSizeExceeded = true;
        this.selectedFile = null;
        this.showFileInput = true;
        return;
      }

      if (!this.allowedFileTypes.includes(fileType)) {
        event.target.value = '';
        this.selectedFile = null;
        this.showError = true;
        this.showFileInput = true;
        return;
      }

      this.userCardUtil.resizeImage(file, 500, 500).subscribe({
            next: (result) => {
              this.selectedFile = result;
              this.currentImage = URL.createObjectURL(result);
            },
            error: () => {
              this.showSnackBar('Error resizing image:', 'error')
            }
          }
      )
    } else {
      this.showFileInput = true;
      this.selectedFile = null;
    }
  }

  getContentIcon(image: string) {
    return this.contentService.getImage(image)
  }

  getImageAsSource(file: File) {
    return URL.createObjectURL(file);
  }

  getPlatformTypes() {
    return Object.values(ContentType).filter(type => type !== ContentType.CONTACT);
  }

  get editContentControl(): any {
    return this.contentForm.controls;
  }

  getAcceptFileType() {
    return this.allowedFileTypes.join(', ');
  }

  private handleErrorResponse(error: any) {
    if (error.status === 404) {
      this.showSnackBar('Content not found.', 'error');
    } else if (error.status === 500) {
      this.showSnackBar('Internal server error.', 'error');
    } else {
      this.showSnackBar('An unexpected error occurred.', 'error');
    }
  }

  private initForm() {
    this.contentForm = this.formBuilder.group({
          name: [this.contentResponse?.name, [Validators.required, Validators.minLength(2), Validators.maxLength(20), this.userCardUtil.whitespaceValidator()]],
          contentType: [this.contentResponse?.contentType, Validators.required],
          contentIcon: [null],
        },
        {
          updateOn: "blur"
        }
    );
  }

  private showSnackBar(message: string, panelClass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: [panelClass]
    });
  }

}
